import {
  NavigateOptions,
  parsePath,
  To,
  useNavigate as useBaseNavigate,
  useSearchParams,
} from 'react-router-dom';

import { useEventCallback } from '@spazious/react-hooks';

import { NavigateFunction } from '../index.js';

/**
 * Modified version of `useNavigate` from `react-router-dom` for
 * keeping search params by default
 */
export const useNavigate = () => {
  const [searchParams] = useSearchParams();
  const navigate = useBaseNavigate();

  return useEventCallback<NavigateFunction>((...args: any[]) => {
    if (typeof args[0] === 'number') {
      navigate(args[0]);
      return;
    }

    const [to, options] = args as [To, NavigateOptions];

    const { pathname, search, ...restPath } = typeof to === 'string' ? parsePath(to) : to;
    navigate(
      {
        ...restPath,
        // Extracted from react-router-dom implementation
        // https://github.com/remix-run/react-router/blob/428ab741024a96768db0fa0c97b17567f4a20d62/packages/react-router/lib/hooks.tsx#L424C3-L424C43
        pathname: pathname || '/',
        search: (search ?? searchParams).toString(),
      },
      options
    );
  });
};
